import React from "react";

// Função para formatar o valor para a moeda brasileira
const formatarMoeda = (valor) => {
  if (valor === undefined || valor === null) return '';
  const numero = parseFloat(valor);
  if (isNaN(numero) || numero === 0) return '';
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
  }).format(numero);
};

// Função para formatar a data para o formato brasileiro
const formatarData = (data) => {
  if (!data) return "";
  const d = new Date(data);
  const dia = String(d.getDate()).padStart(2, "0");
  const mes = String(d.getMonth() + 1).padStart(2, "0");
  const ano = d.getFullYear();
  return `${dia}/${mes}/${ano}`;
};

const ValidadeCard = ({ val }) => {
  const precoCusto = formatarMoeda(val.precocusto);
  const precoVenda = formatarMoeda(val.precovenda);
  const dataLancamento = formatarData(val.dtlancamento);
 
  return (
    <div className="col-12 col-sm-6 col-lg-4 mb-3">
      <div className="card h-100 shadow-sm d-flex flex-column">
        <div className="card-body text-center">
          <img
            
            src={`https://cdn-cosmos.bluesoft.com.br/products/${val.ean}`}
            alt={val.descricao}
            className="img-fluid mb-2"
            style={{ maxHeight: "150px", objectFit: "contain" }}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src =
                "https://multilit.com.br/wp-content/uploads/2020/03/Produto-sem-foto.png";
            }}
          />
          <h5 className="card-title fw-bold">{val.descricao}</h5>
          
          <div className="text-start mt-2">
            <p className="mb-1"><strong>Código:</strong> {val.codigo} - <strong>EAN:</strong> {val.ean} </p>
            <p className="mb-1"><strong>Lançamento:</strong> {dataLancamento}</p>
            <p className="mb-1"><strong>Qtde Venc.:</strong> {val.qtdevencimento}</p>
            <p className="mb-1"><strong>Estoque:</strong> {val.estoque}</p>
            <p className="mb-1"><strong>Custo:</strong> {precoCusto}</p>
            <p className="mb-1 text-error fw-bold"><strong>Venda:</strong> {precoVenda}</p>
          </div>
          <p className="mb-1 nome-color"><strong>Usuário:</strong> {val.nome}</p>
        </div>
      </div>
    </div>
  );
};

export default ValidadeCard;